import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectUserId,
  selectCommentsInCountStat,
  selectCommentsOutCountStat
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import UserInfoBlock from './UserInfoBlock';
import CommentsIn from '../../../../../components/Comment/ReducerWrappers/CommentsIn';
import CommentsOut from '../../../../../components/Comment/ReducerWrappers/CommentsOut';

class MyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <UserInfoBlock />
        <Switch>
          <Route
            exact
            path="/main/my-page"
            render={() => <Redirect from="/" to="/main/my-page/comments" />}
          />
          <Route
            path="/main/my-page/comments"
            render={() => (
              <CommentsIn
                modelClass="User"
                modelId={this.props.authUserId}
                commentsOwnerId={this.props.authUserId}
                commentsInStat={this.props.commentsInStat}
              />
            )}
          />
          <Route
            path="/main/my-page/comments-from-user"
            render={() => (
              <CommentsOut
                userId={this.props.authUserId}
                commentsOwnerId={this.props.authUserId}
                commentsOutStat={this.props.commentsOutStat}
              />
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

MyPage.propTypes = {
  authUserId: PropTypes.string.isRequired,
  commentsInStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,
  commentsOutStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  authUserId: `${selectUserId(state)}`,
  commentsInStat: selectCommentsInCountStat(state),
  commentsOutStat: selectCommentsOutCountStat(state)
});

export default withRouter(connect(mapStateToProps)(MyPage));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyPage/MyPage.js